"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.traverseComponent = exports.traverseField = exports.traversePlaceholder = exports.getContentStylesheetUrl = exports.getContentStylesheetLink = exports.PAGES_SERVER_URL = void 0;
/**
 * Regular expression to check if the content styles are used in the field value
 */
const CLASS_REGEXP = /class=".*(\bck-content\b).*"/g;
exports.PAGES_SERVER_URL = 'https://pages-assets.sitecorecloud.io';
/**
 * Get the content styles link to be loaded from the Pages assets server
 * @param {LayoutServiceData} layoutData Layout service data
 * @param {string} [pagesServerUrl] Sitecore Pages assets server URL. Default is https://pages-assets.sitecorecloud.io
 * @returns {HTMLLink | null} content styles link, null if no styles are used in layout
 */
const getContentStylesheetLink = (layoutData, pagesServerUrl = exports.PAGES_SERVER_URL) => {
    if (!layoutData.sitecore.route)
        return null;
    const config = { loadStyles: false };
    exports.traverseComponent(layoutData.sitecore.route, config);
    if (!config.loadStyles)
        return null;
    return { href: exports.getContentStylesheetUrl(pagesServerUrl), rel: 'stylesheet' };
};
exports.getContentStylesheetLink = getContentStylesheetLink;
const getContentStylesheetUrl = (pagesServerUrl = exports.PAGES_SERVER_URL) => `${pagesServerUrl}/pages/styles/content-styles.min.css`;
exports.getContentStylesheetUrl = getContentStylesheetUrl;
const traversePlaceholder = (components, config) => {
    if (config.loadStyles)
        return;
    components.forEach((component) => {
        exports.traverseComponent(component, config);
    });
};
exports.traversePlaceholder = traversePlaceholder;
const traverseField = (field, config) => {
    if (!field || config.loadStyles)
        return;
    if ('editable' in field && field.editable) {
        config.loadStyles = CLASS_REGEXP.test(field.editable);
    }
    else if ('value' in field && typeof field.value === 'string') {
        config.loadStyles = CLASS_REGEXP.test(field.value);
    }
    else if ('fields' in field) {
        Object.values(field.fields).forEach((field) => {
            exports.traverseField(field, config);
        });
    }
    else if (Array.isArray(field)) {
        field.forEach((field) => {
            exports.traverseField(field, config);
        });
    }
};
exports.traverseField = traverseField;
const traverseComponent = (component, config) => {
    if (config.loadStyles)
        return;
    if ('fields' in component && component.fields) {
        Object.values(component.fields).forEach((field) => {
            exports.traverseField(field, config);
        });
    }
    const placeholders = component.placeholders || {};
    Object.keys(placeholders).forEach((placeholder) => {
        exports.traversePlaceholder(placeholders[placeholder], config);
    });
};
exports.traverseComponent = traverseComponent;
